export const BarcodeLoaderSymbol = Symbol('barcodeLoader');
